module.exports = __webpack_public_path__ + "img/imprimir.3cf63705.svg";